export const resolveThumbnailUrl = (thumbnailUrl, mediaFiles)=>{
    const asUrl = (value)=>{
        if (typeof value === 'string') {
            const trimmed = value.trim();
            return trimmed && trimmed !== '[object Object]' ? trimmed : null;
        }
        if (value && typeof value === 'object' && 'fileUrl' in value) {
            return asUrl(value.fileUrl);
        }
        return null;
    };
    return asUrl(thumbnailUrl) || asUrl(mediaFiles?.[0]) || null;
};
// 레벨 번역 함수
export const translateLevel = (level)=>{
    if (!level) return '';
    switch(level?.toUpperCase()){
        case 'ADVANCED':
            return '고급';
        case 'INTERMEDIATE':
            return '중급';
        case 'BEGINNER':
            return '초급';
        case 'ALL LEVELS':
            return '모든 레벨';
        default:
            return level;
    }
};
// 언어 코드를 국기로 변환
export const normalizeLanguageCode = (code)=>{
    if (!code) {
        return null;
    }
    const trimmed = `${code}`.trim();
    if (trimmed.length === 0) {
        return null;
    }
    const lower = trimmed.toLowerCase();
    // ko-KR 형태는 앞부분만 사용
    if (lower.includes('-')) {
        return lower.split('-')[0];
    }
    return lower;
};
export const getLanguageFlag = (languageCode)=>{
    const normalized = normalizeLanguageCode(languageCode);
    switch(normalized){
        case 'ko':
            return '🇰🇷';
        case 'ja':
            return '🇯🇵';
        case 'en':
            return '🇺🇸';
        case 'zh':
        case 'zh-cn':
            return '🇨🇳';
        case 'zh-tw':
            return '🇹🇼';
        case 'es':
            return '🇪🇸';
        case 'fr':
            return '🇫🇷';
        case 'de':
            return '🇩🇪';
        case 'vi':
            return '🇻🇳';
        default:
            return '🌐';
    }
};
// 언어 코드를 언어명으로 변환
export const getLanguageName = (languageCode)=>{
    const normalized = normalizeLanguageCode(languageCode);
    switch(normalized){
        case 'ko':
            return '한국어';
        case 'ja':
            return '일본어';
        case 'en':
            return '영어';
        case 'zh':
        case 'zh-cn':
            return '중국어(간체)';
        case 'zh-tw':
            return '중국어(번체)';
        case 'es':
            return '스페인어';
        case 'fr':
            return '프랑스어';
        case 'de':
            return '독일어';
        case 'vi':
            return '베트남어';
        default:
            return (normalized ?? languageCode).toUpperCase();
    }
};
export const getLanguageBadgeLabel = (languageCode)=>{
    const normalized = normalizeLanguageCode(languageCode);
    if (!normalized) {
        return '--';
    }
    switch(normalized){
        case 'ko':
            return 'KO';
        case 'ja':
            return 'JA';
        case 'en':
            return 'EN';
        case 'zh':
        case 'zh-cn':
            return 'ZH';
        case 'zh-tw':
            return 'ZH-TW';
        case 'es':
            return 'ES';
        case 'fr':
            return 'FR';
        case 'de':
            return 'DE';
        case 'vi':
            return 'VI';
        default:
            return normalized.toUpperCase();
    }
};
// 레벨에 대한 설명 제공
export const getLevelDescription = (level)=>{
    if (!level) return '';
    switch(level?.toUpperCase()){
        case 'ADVANCED':
            return '프로그래밍 경험이 풍부하고 특정 분야에 대한 깊이 있는 학습을 원하는 분들을 위한 레벨입니다.';
        case 'INTERMEDIATE':
            return '기본적인 프로그래밍 개념을 이해하고 실무 능력을 향상시키고 싶은 분들을 위한 레벨입니다.';
        case 'BEGINNER':
            return '프로그래밍을 처음 시작하거나 기초를 다지고 싶은 입문자분들을 위한 레벨입니다.';
        case 'ALL LEVELS':
            return '초급부터 고급까지 모든 레벨의 수강생을 대상으로 하는 강의입니다.';
        default:
            return `레벨: ${level}`;
    }
};
// 가격 포맷팅 함수
export const formatPrice = (price)=>{
    const amountNumber = parseFloat(price.amount);
    return `₩${isNaN(amountNumber) ? '0' : amountNumber.toLocaleString()}`;
};
// 숫자 직렬화 함수들
export const parseRating = (averageRating)=>{
    if (averageRating === undefined || averageRating === null) return null;
    const value = typeof averageRating === 'string' ? parseFloat(averageRating) : Number(averageRating);
    return isNaN(value) ? null : value;
};
export const parseEnrollmentCount = (enrollmentCount)=>{
    if (!enrollmentCount) return null;
    const value = parseInt(enrollmentCount, 10);
    return isNaN(value) ? null : value;
};
export const parseReviewCount = (reviewCount)=>{
    if (reviewCount === undefined || reviewCount === null) return null;
    const value = typeof reviewCount === 'string' ? parseInt(reviewCount, 10) : Number(reviewCount);
    return isNaN(value) ? null : value;
};
